import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";
import { Options } from "ng5-slider";
import { CommonService } from '../Services/common.service';
import { CardServiceService } from '../Services/card-service.service';
import { AuthService } from '../Services/auth.service';
import { CookieService } from '../Services/cookie';

@Component({
  selector: 'app-card-limit-temporary',
  templateUrl: './card-limit-temporary.component.html',
  standalone:false,
  styleUrls: ['./card-limit-temporary.component.scss']
})
export class CardLimitTemporaryComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  Acceptlimit: any;
  Charges: any;


  constructor(private _router:Router, private location: Location,private common:CommonService,public auth: AuthService,
     public cardService:CardServiceService, private cookieService: CookieService, ) { }

  async ngOnInit(): Promise<any> {
   
    let a =await this.cookieService.get("AutoTempLimitObj",true);
    if(a){

      this.cardService.AutoTempLimitObj = JSON.parse(a);

    }
    this.auth.accessToken = await this.common.Get("token");

   await this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {
       
      } 
      else {
        await this.common.hideLoading();

        this.common.ParseErrorAlert("", "", this._router, data);
      }
    })

  }

  back() {
    this.location.back()
  }

  cardLimitPermanent(){
    this._router.navigateByUrl("/CardLimitPermanent");
  }


  cardLimitSuccess(){
    this._router.navigateByUrl("/CardLimitSuccess");
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  AcceptLimit(){
    this.common.presentLoading();
    this.cardService.AcceptCardLimit(this.cardService.AutoTempLimitObj.limitRequestId,this.auth.accessToken).then((data:any)=>{
      if(data?.response?.code ==1 ){
        this.common.hideLoading();
        this.Acceptlimit = data.response.content;
        console.log('this.Acceptlimit',this.Acceptlimit);
        this._router.navigate(["/CardLimitSuccess"],{queryParams:{Decline: false}})
      }
      else{
        this.common.hideLoading();
        this.common.ParseErrorAlert('','OK',this._router,data);
      }
    })
  }

  Edit(){
  this.common.presentLoading();

   this.cookieService.set("requestedLimit",this.cardService.AutoTempLimitObj.response.requestedLimit,true)
this._router.navigateByUrl('/CardLimitPermanent')
  }

  GetCharges(){
    this.common.presentLoading();
    this.cardService.GetCharges('AUTOTEMP',this.auth.accessToken).then((data:any)=>{
      if(data?.response?.code ==1 ){
        this.common.hideLoading();
        this.Charges = data.response.content;
        console.log('GetCharges',this.Charges);
        this.showModal(2);
      }
      else{
        this.common.hideLoading();
        this.common.ParseErrorAlert('','OK',this._router,data);
      }
    })
  }
  
  Decline(){
    this._router.navigateByUrl("/CardLimitDecline")
  }

}
